import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Silence CRA dev-overlay for benign ResizeObserver loop notifications
// (triggered by Radix Select layout measurement). These are non-fatal and
// otherwise cover the page with an error iframe that blocks pointer events.
const _resizeObserverErrRe = /ResizeObserver loop/;
window.addEventListener("error", (e) => {
  if (e && e.message && _resizeObserverErrRe.test(e.message)) {
    e.stopImmediatePropagation();
  }
});
window.addEventListener("unhandledrejection", (e) => {
  const msg = (e && e.reason && (e.reason.message || String(e.reason))) || "";
  if (_resizeObserverErrRe.test(msg)) {
    e.stopImmediatePropagation();
  }
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
